<template>
  <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color=var(--primary-color)
    :is-full-page="fullPage"
  ></loading>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        
        <DataTable
          
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          showGridlines
          :rowHover="true"
          ><template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
          <!-- Header Row: Title, Export Button, and Total Records -->
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-3">
            <h5><b>Application List</b></h5>
            <div class="flex align-items-center gap-3">
              
              <span>Total Records: {{ totalRecords }}</span>
            </div>
          </div>

          <!-- Filters and Actions Row -->
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3">
            <!-- Filters Section -->
            <div class="flex flex-wrap gap-3">
              <!-- Name Filter -->
              <div class="field w-auto">
                <span class="p-float-label">
                  <InputText type="text" v-model="search_name" v-tooltip.bottom="'search by applicant or patient name'"/>
                  <label for="name">Name</label>
                </span>
              </div>

              <!-- Mobile Filter -->
              <div class="field w-auto">
                <span class="p-float-label">
                  <InputText type="number" v-model="search_mobile" v-tooltip.bottom="'search by applicant or patient mobile'" />
                  <label for="mobile">Mobile</label>
                </span>
              </div>

              <!-- Aadhaar Filter -->
              <div class="field w-auto">
                <span class="p-float-label">
                  <InputText type="number" v-model="search_aadhar" v-tooltip.bottom="'search by applicant or patient adhar'"/>
                  <label for="aadhaar">Aadhaar</label>
                </span>
              </div>

              <!-- Date Filter -->
              <div class="field w-auto">
                <span class="p-float-label">
                  <Calendar id="calendar" v-model="search_date" v-tooltip.bottom="'search by application date'"/>
                  <label for="calendar">Date</label>
                </span>
              </div>

              <!-- Status Filter -->
              <div class="field w-auto">
                <span class="p-float-label" v-tooltip.bottom="'search by Application status'">
                  <Dropdown
                    
                    id="statumaster"
                    v-model="ApplicactionStatusMaster"
                    :options="statusMaster"
                    optionLabel="name"
                    filter
                    
                  />
                  <label for="statumaster" >Status Master</label>
                </span>
              </div>

              <Button
                icon="pi pi-search"
                @click="search(1)"
                class="p-button-rounded p-button-primary"
                v-tooltip.bottom="'Search'"
              />
              <Button
                icon="pi pi-refresh"
                @click="search(2)"
                  class="p-button-rounded p-button-danger"
                
                v-tooltip.bottom="'Refresh'"
              />
              <Button
                icon="pi pi-upload"
                @click="exportCSV($event)"
                class="p-button-rounded p-button-help"

                v-tooltip.bottom="'Export CSV'"
                
              />
            </div>
            </div>

            <!-- Search and Refresh Buttons -->
            
        </template>



        <Column style="max-width: 3rem" header="View" frozen>
            <template #body="slotProps">
              <Button
                icon="pi pi-eye"
                class="p-button-rounded p-button-primary"
                @click="viewProduct(slotProps.data)"
                v-tooltip.bottom="'view application'"
              />
              
            </template>
          </Column>
          <Column header="Status" style="max-width: 5rem" :field="columns[0]" frozen>
            <template #body="{ data }">
              <span >{{data.application_status_name}}</span>
            </template>
          </Column>
          <Column header="No" style="max-width: 5rem" frozen>
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          
          
          <Column header="Patient Name" style="max-width: 5rem" :field="columns[0]" frozen>
            <template #body="{ data }">
              {{ data.parsed_details.patient_name_english }}
            </template>
          </Column>
          <Column header="Patient Mobile" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.parsed_details.patient_relative_mobile }}
            </template>
          </Column>
          <Column header="Patient Aadhar" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.parsed_details.patient_uid }}
            </template>
          </Column>
          
          <Column header="Applicant Name" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.parsed_details.applicant_name }}
            </template>
          </Column>
          <Column header="Applicant Mobile" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.applicant_mobile_number }}
            </template>
          </Column>
          <Column header="Applicant Aadhar" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.parsed_details.applicant_uid }}
            </template>
          </Column>
          <Column header="Applicantion Date" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ D_M_Y_formatDate(data.application_date) }}
            </template>
          </Column>
          <Column header="Approved Amount" style="max-width: 5rem" :field="columns[0]">
            <template #body="{ data }">
              {{ data.approveAmount || 0 }}
            </template>
          </Column>
          
        </DataTable>
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
//import { search } from "core-js/fn/symbol";
export default {
  data() {
    return {
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      search_name:"",
      search_mobile:"",
      search_aadhar:"",
      search_date:"",
      file_attachment: "",
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      statusMaster:[],
      ApplicactionStatusMaster:null,
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
    await this.getApplicationStatusMaster();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        // await this.get_count();
        // this.get_list();
      }
    },
  },
  methods: {
    //a simple date formatting function
    dateFormat(inputDate, info) {},
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];
      //alert(this.$refs.file_attachment.files[0].name);
    },
    async search(count) {
        if (count == 2) {
          this.search_name = "",
          this.search_aadhar = "",
          this.search_date = "",
          this.search_mobile = "",
          this.ApplicactionStatusMaster= ""
        }
        this.loading = true;
        await this.get_list();
        await this.get_count();
        this.loading = false;
        localStorage.setItem("status_id", '');
      },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      // await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    D_M_Y_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = dd + '-' + mm + '-' + yyyy;
                // alert(dd)
                if (dd.toString() != 'NaN') {
                    //this.receipt_new_date = new_date;
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },
        Y_M_D_formatDate(date_parm) {
            if (date_parm) {
                let date = new Date(date_parm);
                let dd = date.getDate();
                let mm = date.getMonth() + 1;
                let yyyy = date.getFullYear();
                let new_date = yyyy + '-' + mm + '-' + dd;
                // alert(dd)
                if (dd.toString() != 'NaN') {
                    //this.receipt_new_date = new_date;
                    return new_date;
                } else {
                    return date_parm;
                }
            }
        },

    get_count: function () {
      const applicationStatus = this.ApplicactionStatusMaster
        ? this.ApplicactionStatusMaster.value
        : null;
      var data = {
        count: true,
        search_name : this.search_name,
        search_mobile : this.search_mobile,
        search_aadhar : this.search_aadhar,
        search_date : this.Y_M_D_formatDate(this.search_date),
        application_status : applicationStatus,
      };
      //this.loading = true;
      var promise = apis.ApplicationList(data, this.id);
      promise.then((response) => {
        //this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      const applicationStatus = this.ApplicactionStatusMaster
        ? this.ApplicactionStatusMaster.value
        : null;
      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
        search_name : this.search_name,
        search_mobile : this.search_mobile,
        search_aadhar : this.search_aadhar,
        search_date : this.Y_M_D_formatDate(this.search_date),
        application_status : applicationStatus,
      };
      console.log("data",data);
      this.loading = true;
      var promise = apis.ApplicationList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;

        this.products.forEach(item => {
                    try {
                        // Parse application_details JSON
                        item.parsed_details = JSON.parse(item.application_details);
                    } catch (error) {
                        console.error('Error parsing application_details:', error, item.application_details);
                        item.parsed_details = {};
                    }
                });
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      //console.log(data);
      
    },
    getApplicationStatusMaster: function () {
      
      var data = { 
       
      };
      this.loading = true;
      var promise = apis.ApplicationStatusMaster(data);
      promise.then((response) => {
        this.loading = false;
        console.log("status",response.data.data);
        this.statusMaster = response.data.data.map(statusM => ({ name: statusM.applicationStatus, value: statusM.id }));
        
        if(localStorage.getItem('status_id')){
          this.id = localStorage.getItem('status_id');
        //console.log("dataid",this.id);

        for (let i = 0; i < this.statusMaster.length; i++) {
          if (this.statusMaster[i]['value'] == this.id) {
            this.ApplicactionStatusMaster = this.statusMaster[i];
             
          }
        }
        this.get_list();
        this.get_count();
        // this.isLoadingModel = false;
         localStorage.setItem("status_id", '');
        }
        
        
      });
      
      //console.log(data);
    },
        
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.id) {
        //
      } else {
        //
      }
      this.productDialog = false;
      this.product = {};
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
    },
    async viewProduct(product)
    {
      this.file_attachment = "";
      this.product = { ...product };
      localStorage.setItem("applicationdata", JSON.stringify(this.product));
      localStorage.setItem("surveydata", JSON.stringify(this.product.application_details));
      this.$router.push({ name: "ApplicationApproval",params:product });
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
